import { render, staticRenderFns } from "./IFPDF.vue?vue&type=template&id=1f030c46"
import script from "./IFPDF.vue?vue&type=script&lang=js"
export * from "./IFPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports